var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73127 17.3334C4.2857 17.3334 0.666748 13.7145 0.666748 9.26893C0.666748 6.77094 1.79712 4.45374 3.76755 2.9114C4.2353 2.54715 4.9107 2.62894 5.27696 3.09621C5.64289 3.56462 5.5605 4.23969 5.09269 4.60629C3.64726 5.73734 2.81729 7.43761 2.81729 9.26893C2.81729 12.5293 5.47018 15.1829 8.73127 15.1829C11.9924 15.1829 14.6452 12.5293 14.6452 9.26893C14.6452 7.4366 13.8156 5.73734 12.3697 4.60495C11.902 4.23835 11.8193 3.56328 12.1854 3.09487C12.5514 2.62746 13.2271 2.54581 13.6948 2.91005C15.6667 4.45374 16.7958 6.77229 16.7958 9.26893C16.7958 13.7145 13.1768 17.3334 8.73127 17.3334Z",
    fill: "#E53451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.70103 10.3444C9.32603 10.3444 9.80654 9.8639 9.80654 9.26914V1.71202C9.80654 1.11827 9.32502 0.666992 8.76152 0.666992C8.13652 0.666992 7.65601 1.14851 7.65601 1.71202V9.26914C7.65601 9.8639 8.13652 10.3444 8.70103 10.3444Z",
    fill: "#E53451"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4551ba6828a3e1834d1a4e343a83d9cf.svg";
export { ForwardRef as ReactComponent };